module.exports = __webpack_public_path__ + "60fde560ff9764f55f70f7e19d40ab3c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/qualcomm_2022_chart.png
// module id = 1727
// module chunks = 0